export const REMAKE_CANCELLATION_REASONS = [
  "Resident Request - Rebooking",
  "Resident Request - Cancel Appointment",
  "Client Request - Rebooking",
  "Client Request - Cancel Appointment",
  "Internal Request - Rebooking",
  "Internal Request - Cancel Appointment",
];

export const WORK_ORDER_CANCELLATION_REASONS = [
  "Resident Request",
  "Client Request",
  "Scheduling Request",
  "Duplicate",
];
